// TODO: remove this file duplicity (there is an useVideoProvider in organizer)
import { Icon } from '@eventbrite/eds-icon';
import { LogoFacebookColor } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import capitalize from 'lodash/capitalize';
import find from 'lodash/find';
import React from 'react';

const PROVIDER_YOUTUBE = 'youtube';
const PROVIDER_VIMEO = 'vimeo';
const PROVIDER_GOOGLE_MEETS = 'google meet';
const PROVIDER_FACEBOOK = 'facebook';

const vimeoUrl = new RegExp(/vimeo/);
const youtubeUrl = new RegExp(/(youtube|youtu\.be)/);
const googleMeetsUrl = new RegExp(/meet.google/);
const facebookUrl = new RegExp(/facebook/);

const providerUrlChecker: { [key: string]: (url: string) => boolean } = {
    [PROVIDER_YOUTUBE]: (url: string): boolean => youtubeUrl.test(url),
    [PROVIDER_VIMEO]: (url: string): boolean => vimeoUrl.test(url),
    [PROVIDER_GOOGLE_MEETS]: (url: string): boolean => googleMeetsUrl.test(url),
    [PROVIDER_FACEBOOK]: (url: string): boolean => facebookUrl.test(url),
};

const youtubeLogo =
    'https://cdn.evbstatic.com/s3-build/perm_001/ab3177/django/images/digital-content/digital-content-youtube-integration-logo.svg';
const vimeoLogo =
    'https://cdn.evbstatic.com/s3-build/perm_001/d492e1/django/images/digital-content/digital-content-vimeo-integration-logo.svg';
const googleMeetsLogo =
    'https://cdn.evbstatic.com/s3-build/perm_001/23c723/django/images/digital-content/digital-content-google-integration-logo.svg';

const providerIcons: { [key: string]: JSX.Element } = {
    [PROVIDER_YOUTUBE]: (
        <img src={youtubeLogo} height="24" alt="Youtube logo" />
    ),
    [PROVIDER_VIMEO]: <img src={vimeoLogo} height="24" alt="Vimeo logo" />,
    [PROVIDER_GOOGLE_MEETS]: (
        <img src={googleMeetsLogo} height="24" alt="Google meets logo" />
    ),
    [PROVIDER_FACEBOOK]: <Icon size="small" type={<LogoFacebookColor />} />,
};

const getVideoProvider = (url: string) => {
    const provider: any = find(
        Object.entries(providerUrlChecker),
        ([provider, urlChecker]) => {
            if (urlChecker(url)) {
                return provider;
            }
            return false;
        },
    );

    return provider?.[0];
};

export const useVideoProvider = (url = '') => {
    const [provider, setProvider] = React.useState(getVideoProvider(url));

    const updateProvider = (url: string) => {
        setProvider(getVideoProvider(url));
    };

    const renderTitle = () => {
        return provider ? capitalize(provider) : gettext('Live Video');
    };

    const renderIcon = () => {
        return provider ? providerIcons[provider] : null;
    };

    return { updateProvider, renderTitle, renderIcon };
};
